import axios from "axios";

const PublishBook = (auth, obj) => {
  return axios.post("library/add", obj, {
    headers: {
      "Content-Type": "multipart/form-data",
      "x-auth-token": auth,
    },
  });
};

const GetAllBooksforUser = (auth) => {
  return axios.get("library/all", {
    headers: {
      "x-auth-token": auth,
    },
  });
};
const SearchBooksWithTitleforUser = (auth, obj) => {
  return axios.post("library/search/buy/auth/title", obj, {
    headers: {
      "x-auth-token": auth,
    },
  });
};
const SearchBooksWithTitleforVisitor = (obj) => {
  return axios.post("library/search/buy/title", obj);
};
const SearchBooksWithAuthorforUser = (auth, obj) => {
  return axios.post("library/search/buy/auth/author", obj, {
    headers: {
      "x-auth-token": auth,
    },
  });
};
const SearchBooksWithAuthorforVisitor = (obj) => {
  return axios.post("library/search/buy/author", obj);
};
const GetAllBooksforVisitor = () => {
  return axios.get("library/alllib");
};
const GetPublisherBooks = (auth) => {
  return axios.get("library/mybooks", {
    headers: {
      "Content-Type": "multipart/form-data",
      "x-auth-token": auth,
    },
  });
};
const EditBook = (auth, obj) => {
  return axios.put("library/edit", obj, {
    headers: {
      "Content-Type": "multipart/form-data",
      "x-auth-token": auth,
    },
  });
};
const DeleteBook = (auth, obj) => {
  return axios.delete("library/delete", {
    headers: {
      "x-auth-token": auth,
    },
    data: obj,
  });
};

const DownloaddBook = (auth, obj) => {
  return axios.post("library/download", obj, {
    headers: {
      "x-auth-token": auth,
    },
  });
};

const RemoveEncryptedBook = (obj) => {
  return axios.delete("library/remove-encrypted-file", {
    data: obj,
  });
};

export {
  PublishBook,
  GetAllBooksforUser,
  GetAllBooksforVisitor,
  GetPublisherBooks,
  EditBook,
  DeleteBook,
  DownloaddBook,
  RemoveEncryptedBook,
  SearchBooksWithTitleforUser,
  SearchBooksWithAuthorforUser,
  SearchBooksWithTitleforVisitor,
  SearchBooksWithAuthorforVisitor,
};
